import type { Airport as AirportProps } from "@airhelp/react";

export const airportsListMock: AirportProps[] = [
  {
    searchText: "Krakow-Balice International Airport, Krakow (KRK)",
    iata: "KRK",
    latitude: 50.077731,
    longitude: 19.784836,
    name: "Krakow-Balice International Airport",
    city: "Krakow",
    cityTranslations: {
      en: "Krakow",
      pl: "Kraków",
      fr: "Cracovie",
      pt: "Cracóvia",
      it: "Cracovia",
      el: "Κρακοβία",
      ru: "Краков",
      nb: "Krakow",
      sv: "Krakow",
      da: "Krakow",
      de: "Krakow",
      fi: "Krakova",
      es: "Cracovia",
      nl: "Krakau",
      "pt-BR": "Cracóvia",
      "zh-CN": "克拉科夫",
    },
    country: "Poland",
    countryCode: "PL",
    ec261: true,
    rank: 7,
    timeZone: "Europe/Warsaw",
  },
  {
    searchText: "Pashkovskiy Airport, Krasnodar (KRR)",
    iata: "KRR",
    latitude: 45.034722,
    longitude: 39.170278,
    name: "Pashkovskiy Airport",
    city: "Krasnodar",
    cityTranslations: {},
    country: "Russian Federation",
    countryCode: "RU",
    ec261: false,
    rank: 4,
    timeZone: "Europe/Moscow",
  },
  {
    searchText: "Krasnojarsk Airport, Krasnojarsk (KJA)",
    iata: "KJA",
    latitude: 56.18113,
    longitude: 92.48286,
    name: "Krasnojarsk Airport",
    city: "Krasnojarsk",
    cityTranslations: {},
    country: "Russian Federation",
    countryCode: "RU",
    ec261: false,
    rank: 3,
    timeZone: "Asia/Krasnoyarsk",
  },
  {
    searchText: "Krasnojarsk Airport, Krasnojarsk (KJA)",
    iata: "KJA",
    latitude: 56.18113,
    longitude: 92.48286,
    name: "Krasnojarsk Airport",
    city: "Krasnojarsk",
    cityTranslations: {},
    country: "Russian Federation",
    countryCode: "RU",
    ec261: false,
    rank: 3,
    timeZone: "Asia/Krasnoyarsk",
  },
  {
    searchText: "Krakor, Krakor (KZD)",
    iata: "KZD",
    latitude: 12.533333,
    longitude: 104.15,
    name: "Krakor",
    city: "Krakor",
    cityTranslations: {},
    country: "Cambodia",
    countryCode: "KH",
    ec261: false,
    rank: 0,
    timeZone: "Asia/Phnom_Penh",
  },
];
